import { c as _c } from "react/compiler-runtime";
import { cn } from '../../../shared/cn';
import type { TextProps } from './textProps';
export function Text(t0) {
  const $ = _c(10);
  let className;
  let props;
  let underscore;
  if ($[0] !== t0) {
    ({
      className,
      underscore,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = underscore;
  } else {
    className = $[1];
    props = $[2];
    underscore = $[3];
  }
  const t1 = underscore && "underline";
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cn(t1, "font-semibold text-contentPrimary text-sm leading-5", className);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <p data-slot="text" {...props} className={t2} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}